import { Info } from "lucide-react";
import dayjs from "dayjs";

import { Card } from "@ui/card";
import { BasicCalender } from "@components/items/display/Calender";
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover";
import { BasicBars } from "@components/items/display/Bars";
import TranslatedText from "@components/items/display/TranslatedText";
import { translate } from "@modules/localizations/translate";
import { useLanguage } from "@modules/localizations/LanguageContext";

interface ContinuityProps {
  stats: { prevStreak: number; currentStreak: number; bestStreak: number };
  streakDays: Date[];
  onStreakDateChange: (fromDate: string, toDate: string) => void;
}

const Continuity = ({
  stats,
  streakDays,
  onStreakDateChange,
}: ContinuityProps) => {
  const { language } = useLanguage();

  return (
    <Card className="flex min-h-[425px] w-full flex-col items-start justify-center border-none bg-[#D9D9D9]/15 p-5 text-black dark:text-white">
      <div className="flex w-full items-center justify-between">
        <TranslatedText
          text={`settings.titles.${"continuity"}`}
          className="text-[25px] font-medium"
        />
        <Popover>
          <PopoverTrigger>
            <Info size={25} className="cursor-pointer text-[#DDDDDD]" />
          </PopoverTrigger>
          <PopoverContent
            align="end"
            className="bg-[#FFFFFF] text-[15px] text-[#898A8D] dark:bg-[#37383F]"
          >
            <TranslatedText text="settings.titles.profile continuity tooltip" />
          </PopoverContent>
        </Popover>
      </div>
      <div className="flex min-h-[400px] w-full items-end justify-around py-5">
        <BasicCalender
          selectedDates={streakDays}
          onMonthChange={(month) => {
            onStreakDateChange(
              dayjs(month).format("YYYY-MM-DD"),
              dayjs(month).endOf("month").format("YYYY-MM-DD")
            );
          }}
          lang={language}
        />
        <div className="flex h-[370px] w-[300px] rounded-md bg-white p-8 pb-4 dark:bg-[#1C1C1C]">
          <BasicBars
            data={[
              {
                id: 1,
                label: "Hi",
                value: stats.prevStreak,
                barColor: "#AFEB8A",
                svgColor: "#D6FFBD",
              },
              {
                id: 2,
                label: "Hi",
                value: stats.currentStreak,
                barColor: "#FBBF28",
                svgColor: "#FCDB7D",
              },
              {
                id: 3,
                label: "Hi",
                value: stats.bestStreak,
                barColor: "#F79A97",
                svgColor: "#fcc7c4",
              },
            ]}
            spacing={3}
            barLabels={[
              translate("settings.titles.previous result"),
              translate("settings.titles.current continuity"),
              translate("settings.titles.best result"),
            ]}
            width="71px"
          />
        </div>
      </div>
    </Card>
  );
};

export default Continuity;
